/*!
 * @pixi/canvas-text - v6.0.0
 * Compiled Tue, 02 Mar 2021 21:45:03 UTC
 *
 * @pixi/canvas-text is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */
import{Text as t}from"@pixi/text";import{Sprite as i}from"@pixi/sprite";t.prototype._renderCanvas=function(t){this._autoResolution&&this._resolution!==t.resolution&&(this._resolution=t.resolution,this.dirty=!0),this.updateText(!0),i.prototype._renderCanvas.call(this,t)};
//# sourceMappingURL=canvas-text.min.js.map
